<template>
  <!-- 其他  -->
  <div class="declare">
    <!-- <el-form-item
      label="邮箱"
      prop="other_mail"
    >
      <el-input
        style="width:500px"
        type="text"
        v-model="ruleForm.other_mail"
        autocomplete="off"
        placeholder="请输入邮箱"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="联系人"
      prop="other_people"
    >
      <el-input
        style="width:740px"
        type="text"
        v-model="ruleForm.other_people"
        autocomplete="off"
        placeholder="请输入联系人"
      ></el-input>
    </el-form-item> -->
  </div>
</template>

<script>
export default {
  name: 'other',
  props: ['ruleForm'],
  components: {
  },
}

</script>
<style lang="less" scoped>
</style>